:host{height:100%}.workspace-outline{border:1px solid #e9ebed;background-color:#fff;display:block}
/*# sourceMappingURL=workspace-styles.css.map */
